<template>

  <div v-bind:style="{color: survey.colors.text_color}">
      <div class="hit-form-group">
        <div class="hit-col-md-12">
          <label class="hit-html-label">{{ $tc('message.passwordProtected', 1, {name: $tc('message.board', 1)+" "+survey.name}) }}</label>

          <div class="hit-form-group">
          <div class="hit-input-group">
            <span class="hit-input-group-addon"  v-bind:style="{color: survey.colors.background_color, 'background-color': survey.colors.accent_color, 'border-color': survey.colors.accent_color}">
              <i class="hit-glyphicon hit-glyphicon-lock"></i>
            </span>
            <input v-bind:style="{color: survey.colors.text_color, 'background-color': survey.colors.background_color, 'border-color': survey.colors.accent_color}" class="hit-form-control" v-model="pass" type="password" v-bind:placeholder="$t('message.password')">
          </div>
        </div>
        </div>
    </div>
  </div>

</template>

<script>

export default{

  props: {survey: Object, callback: Function},

  data: function () {
    return {
      pass: ''
    }
  },

  watch: {
    pass: function (val) {
      if (val == this.survey.pass) { this.callback(val) }
    }
  }

}

</script>
